import { PartialDeep } from '@trukt/types/TypeFest';
import { v4 as uuid } from 'uuid';

export const createKey = (key: string) => ({
  key: [key],
  createMethod: <T = unknown>() => {
    const id = uuid();
    return (request?: PartialDeep<T>): [string, string, PartialDeep<T>?] =>
      request ? [key, id, request] : [key, id];
  },
});
